import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";


import React, { useEffect, useState } from "react";
import { db } from "../firebase";

import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";



// =========================
// ACTION BAR & BUTTON UI
// =========================
const actionBarStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
  padding: "12px 16px",
  background: "#f8f9fb",
  border: "1px solid #e3e6ea",
  borderRadius: "8px",
  marginBottom: "14px",
};

const baseBtn = {
  padding: "8px 16px",
  fontSize: "14px",
  fontWeight: 500,
  borderRadius: "6px",
  cursor: "pointer",
  transition: "all 0.15s ease",
};

const primaryBtn = {
  ...baseBtn,
  background: "#198754", // green
  color: "#fff",
  border: "1px solid #198754",
};

const dangerBtn = {
  ...baseBtn,
  background: "#dc3545", // red
  color: "#fff",
  border: "1px solid #dc3545",
};

const utilityBtn = {
  ...baseBtn,
  background: "#198754",
  color: "#fff",
  border: "1px solid #198754",
};



function PendingOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [skuMaster, setSkuMaster] = useState({});
  
  const pressAnim = {
  onMouseDown: (e) =>
    (e.currentTarget.style.transform = "scale(0.96)"),
  onMouseUp: (e) =>
    (e.currentTarget.style.transform = "scale(1)"),
  onMouseLeave: (e) =>
    (e.currentTarget.style.transform = "scale(1)"),
};


  // -------------------------
  // Load SKU Master
  // -------------------------
  const loadSkuMaster = async () => {
    const snap = await getDocs(collection(db, "skuMaster"));
    let m = {};
    snap.docs.forEach((d) => {
      const data = d.data();
      if (data.sku) {
        m[data.sku.trim().toLowerCase()] = data;
        if (data.Name) {
          m[data.Name.trim().toLowerCase()] = data;
        }
      }
    });
    setSkuMaster(m);
  };

  // -------------------------
  // Date parser
  // -------------------------
  const parseDate = (dateStr) => {
    if (!dateStr) return new Date(0);

    if (typeof dateStr === "object" && dateStr.seconds) {
      return new Date(dateStr.seconds * 1000);
    }

    if (typeof dateStr === "string") {
      const parts = dateStr.split("/");
      if (parts.length !== 3) return new Date(0);
      const [dd, mm, yyyy] = parts;
      return new Date(`${yyyy}-${mm}-${dd}`);
    }

    return new Date(0);
  };

  // -------------------------
  // Reject Order (KEEP SINGLE)
  // -------------------------
  const rejectOrder = async (orderId) => {
    try {
      const ok = window.confirm("Are you sure you want to reject this order?");
      if (!ok) return;

      await updateDoc(doc(db, "orders", orderId), {
        status: "REJECTED",
        updatedAt: serverTimestamp(),
      });

      setOrders((prev) => prev.filter((o) => o.id !== orderId));
      alert("Order rejected");
    } catch (err) {
      console.error(err);
      alert("Failed to reject order");
    }
  };

  const [userProfile, setUserProfile] = useState(null);

  // -------------------------
  // Load Pending Orders
  // -------------------------
  const loadOrders = async (profile) => {
    let q;
    if (profile?.role === "distributor") {
      q = query(collection(db, "orders"), where("status", "==", "PENDING"), where("distributorId", "==", profile.partyId || ""));
    } else {
      q = query(collection(db, "orders"), where("status", "==", "PENDING"));
    }
    const snap = await getDocs(q);

    let list = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    list.sort((a, b) => parseDate(b.createdAt) - parseDate(a.createdAt));
    setOrders(list);
  };

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) { navigate("/"); return; }
      const snap = await getDoc(doc(db, "users", user.uid));
      if (snap.exists()) {
        const profile = snap.data();
        setUserProfile(profile);
        loadSkuMaster();
        loadOrders(profile);
      }
    });
    return () => unsub();
  }, [navigate]);

  useEffect(() => {
    if (!userProfile) return;
    const interval = setInterval(() => {
      loadOrders(userProfile);
    }, 10000);
    return () => clearInterval(interval);
  }, [userProfile]);


  // -------------------------
  // Calculate Total Amount
  // -------------------------
  const calcOrderTotal = (items) => {
    let total = 0;

    Object.keys(items || {}).forEach((sku) => {
      const qty = Number(items[sku] || 0);
      const key = sku.trim().toLowerCase();
      const m = skuMaster[key] || {};

      const rate = Number(m.Basic_Eway || 0);
      const basic = qty * rate;
      
	  const mrpTotal = qty * (Number(m.mrp) || 0);
	  const gst = mrpTotal - (mrpTotal / (1 + ((Number(m.gst) || 0) / 100)));
      
	  const cess = basic * ((Number(m.cess) || 0) / 100);
      const addl = qty * (Number(m.addlcess) || 0);
      const rebate = qty * (Number(m.Rebate || 0));

      total += basic + gst + cess + addl + rebate;
    });

    return total;
  };


// ==============================
// EXPORT PENDING ORDERS TO EXCEL
// ==============================
const exportPendingOrders = () => {
  if (!orders.length) {
    alert("No pending orders to export");
    return;
  }

  const rows = [];

  orders.forEach((order) => {
    Object.entries(order.items || {}).forEach(([sku, qty]) => {
      if (!qty || Number(qty) === 0) return;

      rows.push({
        CreatedAt: order.createdAt?.seconds
          ? new Date(order.createdAt.seconds * 1000).toLocaleDateString("en-IN")
          : "",
        PartyId: order.partyId || "",
        SKU: sku,
        Qty: Number(qty),
      });
    });
  });

  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "PendingOrders");

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([wbout]), `Pending_Orders_${new Date().toISOString().slice(0,10)}.xlsx`);
};






  // -------------------------
  // Render
  // -------------------------
  
  // -------------------------
  // Render
  // -------------------------

  const metrics = React.useMemo(() => {
    let tQty = 0;
    let tAmt = 0;
    orders.forEach(o => {
      tQty += 1;
      tAmt += calcOrderTotal(o.items);
    });
    return { count: tQty, totalAmount: tAmt };
  }, [orders, skuMaster]);

  return (
    <Layout>
      <div className="layout-content">
        {/* HEADER SECTION */}
        <div style={{ marginBottom: 40, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
                <h1 style={{ fontSize: 32, marginBottom: 8, fontWeight: 900, letterSpacing: "-0.02em" }}>Order Queue Protocol</h1>
                <p style={{ color: "var(--text-muted)", fontSize: 16 }}>Real-time synchronization of inbound field requisitions awaiting authorization.</p>
            </div>
            <div style={{ display: "flex", gap: 30 }}>
                <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 24, fontWeight: 800, color: "var(--primary)" }}>{metrics.count}</div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em" }}>Pending Loads</div>
                </div>
                <div style={{ width: 1, height: 40, background: "var(--border)" }}></div>
                <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 24, fontWeight: 800, color: "var(--text-main)" }}>₹{metrics.totalAmount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}</div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em" }}>Projected Volume</div>
                </div>
            </div>
        </div>

        {/* COMMAND BAR */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 32, gap: 16 }}>
            <div style={{ display: "flex", gap: 12 }}>
                <button
                    className="btn-primary"
                    style={{ background: "var(--text-main)", display: "flex", alignItems: "center", gap: 10 }}
                    onClick={exportPendingOrders}
                >
                    <span style={{ fontSize: 18 }}>📥</span> 
                    <span>EXPORT MANIFEST</span>
                </button>
                <button
                    className="btn-secondary"
                    onClick={() => {
                        const pass = prompt("Enter secure ingestion key");
                        if (pass === "1234bulk") {
                            window.location.href = "/bulk-order-upload";
                        } else {
                            alert("Authorization failed");
                        }
                    }}
                >
                    DATA INGESTION
                </button>
            </div>
            
            <button
                onClick={() => window.location.href = "/master-pending"}
                className="btn-secondary"
                style={{ 
                    background: "var(--surface)", 
                    fontWeight: 800, 
                    border: "2px solid var(--primary)",
                    color: "var(--primary)",
                    padding: "10px 24px"
                }}
            >
                📊 MASTER GRID EDITOR
            </button>
        </div>

        {/* DATA GRID */}
        <div className="premium-card" style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ padding: "16px 24px", borderBottom: "1px solid var(--border)", background: "var(--surface-hover)", display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontSize: 11, fontWeight: 800, color: "var(--text-muted)", textTransform: "uppercase" }}>Pending Requisition Registry</span>
                <span style={{ fontSize: 11, fontWeight: 800, color: "var(--primary)" }}>SYNCING LIVE...</span>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table className="enterprise-table">
                <thead>
                  <tr>
                    <th style={{ paddingLeft: 24 }}>PARTY IDENTIFICATION</th>
                    <th style={{ textAlign: "center" }}>TOTAL LOAD</th>
                    <th style={{ textAlign: "right" }}>AGGREGATE VALUE</th>
                    <th style={{ textAlign: "center" }}>SUBMISSION DATE</th>
                    <th style={{ textAlign: "right", paddingRight: 24 }}>OPERATIONAL ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length === 0 ? (
                    <tr>
                        <td colSpan="5" style={{ padding: 100, textAlign: "center", color: "var(--text-muted)" }}>
                            <div style={{ fontSize: 40, marginBottom: 16 }}>🌤️</div>
                            <div style={{ fontWeight: 700, fontSize: 16 }}>Queue is Clear</div>
                            <p style={{ fontSize: 13, marginTop: 4 }}>No inbound orders requiring attention at this time.</p>
                        </td>
                    </tr>
                  ) : (
                    orders.map((order) => {
                      const totalAmt = calcOrderTotal(order.items);
                      const calcQty = (items) => {
                        let q = 0;
                        Object.keys(items || {}).forEach((sku) => {
                          q += Number(items[sku] || 0);
                        });
                        return q;
                      };

                      return (
                        <tr key={order.id}>
                          <td style={{ paddingLeft: 24 }}>
                            <div style={{ fontWeight: 800, color: "var(--text-main)", fontSize: 15 }}>{order.partyName}</div>
                            <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}>REF: {order.id.slice(0, 8).toUpperCase()}</div>
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 700 }}>
                            {Number(calcQty(order.items)).toFixed(0)} <span style={{ fontSize: 10, color: "var(--text-muted)" }}>PACKETS</span>
                          </td>
                          <td style={{ textAlign: "right", fontWeight: 900, fontSize: 15, color: "var(--primary)" }}>
                            ₹{Number(totalAmt).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                          </td>
                          <td style={{ textAlign: "center", fontSize: 13, color: "var(--text-muted)" }}>
                            {order.createdAt?.seconds ? new Date(order.createdAt.seconds * 1000).toLocaleDateString("en-IN", { day: '2-digit', month: 'short', year: 'numeric' }) : "-"}
                          </td>
                          <td style={{ textAlign: "right", paddingRight: 24 }}>
                            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                              <button
                                className="btn-primary"
                                style={{ padding: "6px 16px", fontSize: 12, borderRadius: 8 }}
                                onClick={() => navigate(`/approve-order/${order.id}`)}
                              >
                                AUTHORIZE
                              </button>
                              <button
                                className="btn-secondary"
                                style={{ padding: "6px 16px", fontSize: 12, borderRadius: 8, color: "var(--danger)", borderColor: "rgba(239, 68, 68, 0.2)" }}
                                onClick={() => rejectOrder(order.id)}
                              >
                                TERMINATE
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
        </div>
      </div>
    </Layout>
  );
}

export default PendingOrders;
